import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";
import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";

const createEtransferStyle = {
	...customSelectStyle,
	...customCheckboxRadioSwitch
};

export default createEtransferStyle;
